/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Errors_Invalidimageformat2Inputs */

const id_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format gambar tidak valid`)
};

const ms_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format imej tidak sah`)
};

const da_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ugyldigt billedformat`)
};

const de_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültiges Bildformat`)
};

const en_us2_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid image format`)
};

const es_es2_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de imagen no válido`)
};

const es_mx2_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de imagen no válido`)
};

const fil_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi valid na format ng larawan`)
};

const fr_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format d'image non valide`)
};

const it_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato immagine non valido`)
};

const hu_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Érvénytelen képformátum`)
};

const nl_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeldig afbeeldingsformaat`)
};

const no_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ugyldig bildeformat`)
};

const pl_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieprawidłowy format obrazu`)
};

const pt_br2_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de imagem inválido`)
};

const pt_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de imagem inválido`)
};

const ro_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format imagine invalid`)
};

const fi_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virheellinen kuvamuoto`)
};

const sv_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogiltigt bildformat`)
};

const vi_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Định dạng hình ảnh không hợp lệ`)
};

const tr_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geçersiz görsel formatı`)
};

const cs_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neplatný formát obrázku`)
};

const bg_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Невалиден формат на изображението`)
};

const ru_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неверный формат изображения`)
};

const uk_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Невірний формат зображення`)
};

const ar_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنسيق صورة غير صالح`)
};

const hi_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अमान्य छवि प्रारूप`)
};

const th_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รูปแบบรูปภาพไม่ถูกต้อง`)
};

const ja_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無効な画像形式`)
};

const zh_cn2_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无效的图像格式`)
};

const zh_hant1_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無效的圖像格式`)
};

const ko_profile_errors_invalidimageformat2 = /** @type {(inputs: Profile_Errors_Invalidimageformat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잘못된 이미지 형식`)
};

/**
* | output |
* | --- |
* | "Invalid image format" |
*
* @param {Profile_Errors_Invalidimageformat2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_errors_invalidimageformat2 = /** @type {((inputs?: Profile_Errors_Invalidimageformat2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Errors_Invalidimageformat2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_errors_invalidimageformat2(inputs)
	if (locale === "ms") return ms_profile_errors_invalidimageformat2(inputs)
	if (locale === "da") return da_profile_errors_invalidimageformat2(inputs)
	if (locale === "de") return de_profile_errors_invalidimageformat2(inputs)
	if (locale === "en-US") return en_us2_profile_errors_invalidimageformat2(inputs)
	if (locale === "es-ES") return es_es2_profile_errors_invalidimageformat2(inputs)
	if (locale === "es-MX") return es_mx2_profile_errors_invalidimageformat2(inputs)
	if (locale === "fil") return fil_profile_errors_invalidimageformat2(inputs)
	if (locale === "fr") return fr_profile_errors_invalidimageformat2(inputs)
	if (locale === "it") return it_profile_errors_invalidimageformat2(inputs)
	if (locale === "hu") return hu_profile_errors_invalidimageformat2(inputs)
	if (locale === "nl") return nl_profile_errors_invalidimageformat2(inputs)
	if (locale === "no") return no_profile_errors_invalidimageformat2(inputs)
	if (locale === "pl") return pl_profile_errors_invalidimageformat2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_errors_invalidimageformat2(inputs)
	if (locale === "pt") return pt_profile_errors_invalidimageformat2(inputs)
	if (locale === "ro") return ro_profile_errors_invalidimageformat2(inputs)
	if (locale === "fi") return fi_profile_errors_invalidimageformat2(inputs)
	if (locale === "sv") return sv_profile_errors_invalidimageformat2(inputs)
	if (locale === "vi") return vi_profile_errors_invalidimageformat2(inputs)
	if (locale === "tr") return tr_profile_errors_invalidimageformat2(inputs)
	if (locale === "cs") return cs_profile_errors_invalidimageformat2(inputs)
	if (locale === "bg") return bg_profile_errors_invalidimageformat2(inputs)
	if (locale === "ru") return ru_profile_errors_invalidimageformat2(inputs)
	if (locale === "uk") return uk_profile_errors_invalidimageformat2(inputs)
	if (locale === "ar") return ar_profile_errors_invalidimageformat2(inputs)
	if (locale === "hi") return hi_profile_errors_invalidimageformat2(inputs)
	if (locale === "th") return th_profile_errors_invalidimageformat2(inputs)
	if (locale === "ja") return ja_profile_errors_invalidimageformat2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_errors_invalidimageformat2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_errors_invalidimageformat2(inputs)
	return ko_profile_errors_invalidimageformat2(inputs)
});
export { profile_errors_invalidimageformat2 as "profile.errors.invalidImageFormat" }